import { css } from '@emotion/core';

import { SEARCH_MIN_HEIGHT } from '../styles';

export const root = css`
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const param = css`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  min-height: ${SEARCH_MIN_HEIGHT};
`;

export const terms = css`
  display: flex;

  padding-left: 6px;
`;
